/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Ref_N7Inputs */

const en_to_typescript_ref_n7 = /** @type {(inputs: To_Typescript_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only arrays reveal optionality. A key missing from some elements gets a question mark.`)
};

const ko_to_typescript_ref_n7 = /** @type {(inputs: To_Typescript_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선택성은 배열에서만 드러납니다. 일부 요소에서 빠진 키에 물음표가 붙습니다.`)
};

const ja_to_typescript_ref_n7 = /** @type {(inputs: To_Typescript_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意性は配列でしか現れません。一部の要素で欠けたキーに疑問符が付きます。`)
};

/**
* | output |
* | --- |
* | "Only arrays reveal optionality. A key missing from some elements gets a question mark." |
*
* @param {To_Typescript_Ref_N7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_ref_n7 = /** @type {((inputs?: To_Typescript_Ref_N7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Ref_N7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_ref_n7(inputs)
	if (locale === "ko") return ko_to_typescript_ref_n7(inputs)
	return ja_to_typescript_ref_n7(inputs)
});